export default "__VITE_ASSET__5glJWtTH__"